/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Registration_Status_PendingInputs */

const en_admin_registration_status_pending = /** @type {(inputs: Admin_Registration_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending`)
};

const de_admin_registration_status_pending = /** @type {(inputs: Admin_Registration_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausstehend`)
};

/**
* | output |
* | --- |
* | "Pending" |
*
* @param {Admin_Registration_Status_PendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_registration_status_pending = /** @type {((inputs?: Admin_Registration_Status_PendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Registration_Status_PendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_registration_status_pending(inputs)
	return en_admin_registration_status_pending(inputs)
});